<template>
    <div class="cemetery-sectors-list" :id="dataParent">
        <CemeterySectorItem
            v-for="(item, idx) in value"
            :key="`cemetery-sector-item-${idx}`"
            :value="item"
            :cemeteryCode="cemeteryCode"
            :panelCfg="panelCfg"
            :additional="additional"
            :baseTranslateID="baseTranslateID"
            :enableViewDetail="allowViewDetail"
            :enableViewOnMap="allowViewOnMap"
            :enableViewOccupation="allowViewOccupation"
            @viewDetail="onViewDetail"
            @viewOnMap="onViewOnMap" />
    </div>
</template>

<script>
    import CemeteryElementMixin from "../mixins/CemeteryElementMixin";

    export default {
        mixins: [
            CemeteryElementMixin
        ],
        components: {
            CemeterySectorItem: () => import(/* webpackChunkName: "cemeteries-cemeterysectoritem" */ './CemeterySectorItem'),
        },
        props: {
            value: {
                type: Array,
                default: () => {
                    return [];
                },
            },
            cemeteryCode: {
                type: [Number, String],
                default: null,
            },
        },
        data() {
            return {
                dataParent: 'treeCemeterySectors',
            }
        },
        computed: {
            allowViewDetail() {
                return this.actions?.detail ?? false;
            },
            allowViewOnMap() {
                return true;
            },
            allowViewOccupation() {
                return this.actions?.occupation.show ?? false;
            },
        },
        methods: {
            onViewDetail(params={}) {
                if(this.allowViewDetail) {
                    this.$emit('viewSector', params);
                }
            },
            onViewOnMap(feature=null) {
                if(this.allowViewOnMap) {
                    this.$emit('highlight', feature);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>